import { useFieldArray, useFormContext } from "react-hook-form";
import Addicon from "@mui/icons-material/Add";
import TrashLineIcon from "remixicon-react/DeleteBin2LineIcon";
import { createUseStyles } from "$utils/createUseStyles";
import Divider from "@mui/material/Divider";
import { theme } from "$utils/theme/bataillog";
import CField, { CFieldInputProps } from "$forms/CField";
import { CompanyType, StockItConfigType, WMSConfigType } from "$types";
import { Button, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import CompanySelect from "$forms/CompanySelect";

const statusLabel = [
  { value: "todo", label: "À Faire" },
  { value: "in_progress", label: "En cours" },
  { value: "prepared", label: "Préparée" },
  { value: "shipped", label: "En cours de livraison" },
  { value: "delivered", label: "Livrée" },
  { value: "received", label: "Reçue" },
];

function StockItConfig() {
  const { jclasses } = useJStyles();
  const classes = useStyles();
  const {
    control,
    formState: { errors },
  } = useFormContext<WMSConfigType<StockItConfigType>>();
  const {
    fields: providersFields,
    remove,
    insert,
  } = useFieldArray({
    control,
    name: "config.providers",
  });

  return (
    <div>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <CField
            label="Répertoire d'entrée"
            control={control}
            name="config.inputDir"
            required
            error={errors?.config?.inputDir}
          />
        </div>
        <div className={classes.newFormFieldsCol}>
          <CField
            label="Répertoire de sortie"
            control={control}
            name="config.outputDir"
            required
            error={errors?.config?.outputDir}
          />
        </div>
      </div>
      <div className={classes.newFormFieldsRow}>
        <CField
          label="Code entrepôt"
          control={control}
          name="config.warehouseCode"
          required
          error={errors?.config?.warehouseCode}
        />
      </div>

      <div>
        <Divider />
        <Text type="h3">Configuration du FTP</Text>
        <div className={classes.newFormFieldsRow}>
          <CField
            label="Host"
            control={control}
            name="config.ftpHostname"
            required
            error={errors?.config?.ftpHostname}
          />
        </div>
        <div className={classes.newFormFieldsRow}>
          <div className={classes.newFormFieldsCol}>
            <CField
              label="Utilisateur"
              control={control}
              name="config.ftpUser"
              required
              error={errors?.config?.ftpUser}
            />
          </div>
          <div className={classes.newFormFieldsCol}>
            <CField
              label="Mot de passe"
              control={control}
              name="config.ftpPassword"
              required
              error={errors?.config?.ftpPassword}
            />
          </div>
        </div>
      </div>

      <div>
        <Divider />
        <Text type="h3">Status</Text>
        {statusLabel.map((status) => (
          <div key={status.value} className={classes.newFormFieldsRow}>
            <div className={classes.newFormFieldsCol}>
              <Text type="text">{status.label}</Text>
            </div>
            <div className={classes.newFormFieldsCol}>
              <CField
                control={control}
                name={`config.status.${status.value}`}
                required
                // error={errors.config?.status[status.value]}
              />
            </div>
          </div>
        ))}
      </div>

      <Divider />
      <Text type="h3">Association entreprises</Text>
      {providersFields.map((provider, index) => (
        <div className={classes.newFormFieldsRow} key={provider.id}>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{ width: "95%" }}
              control={control}
              name={`config.providers.${index}.companyId`}
              required
              error={errors.config?.providers?.[index]?.companyId}
            >
              {(props: CFieldInputProps) => (
                <CompanySelect
                  {...props}
                  companyTypes={[CompanyType.CLIENT]}
                  placeholder=""
                  key={props.value}
                  minCharsToTrigerSearch={0}
                  rowsPerPage={99999}
                />
              )}
            </CField>
          </div>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{ width: "95%" }}
              label="Code fournisseur"
              control={control}
              name={`config.providers.${index}.code`}
              required
              error={errors.config?.providers?.[index]?.code}
            />
          </div>
          <Button
            color="primary"
            onClick={() => {
              remove(index);
            }}
            style={{
              color: theme.color.red,
              alignItems: "end",
              maxWidth: 50,
            }}
          >
            <TrashLineIcon />
          </Button>
        </div>
      ))}
      <Button
        className={jclasses.jAddCta}
        variant="outlined"
        onClick={async () => {
          insert(providersFields.length, { companyId: "", code: "" });
        }}
      >
        <Addicon />
        Ajouter une nouvelle association
      </Button>
    </div>
  );
}

export default StockItConfig;

const useStyles = createUseStyles(() => ({
  newFormFieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
    gap: theme.spacing(1),
  },
  newFormFieldsCol: {
    flex: 1,
  },
}));
